import "@/App.css";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import Services from "@/components/Services";
import Pricing from "@/components/Pricing";
import Clients from "@/components/Clients";
import WhyUs from "@/components/WhyUs";
import ServiceDetails from "@/components/ServiceDetails";
import TechStack from "@/components/TechStack";
import Owner from "@/components/Owner";
import Footer from "@/components/Footer";

function App() {
  return (
    <LanguageProvider>
      <div className="App" data-testid="app-root">
        <Header />
        <main>
          <Hero />
          <Services />
          <Pricing />
          <Clients />
          <WhyUs />
          <ServiceDetails />
          <TechStack />
          <Owner />
        </main>
        <Footer />
      </div>
    </LanguageProvider>
  );
}

export default App;
